/**
 * This bootstrap file is used for both frontend and backend
 */

import _ from 'lodash'

import List_Methods from '@interfaces/list_methods'
import axios from 'axios'
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'popper.js'; // Required for BS4
import 'bootstrap';

import Methods from '@interfaces/methods'

import moment from 'moment';
import 'moment-timezone';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.moment = moment;
window.$ = window.jQuery = $;
window.Swal = Swal;
window._ = _; // Lodash
window.Methods = Methods;
window.List_Methods = List_Methods


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    encrypted: true
});


// Function to get today's date as a string in 'YYYY-MM-DD' format
function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

// Retrieve stored date from localStorage
let storedDate = localStorage.getItem('pusherConnectionDate');

// Get today's date
let currentDate = getCurrentDate();

// Check if the stored date is different from today's date
if (storedDate !== currentDate) {
    
    // Disconnect from Pusher if already connected
    if (window.Echo.connector.pusher.connection.state === 'connected') {
        window.Echo.connector.pusher.disconnect();
        console.log('Disconnected from Pusher before establishing a new connection.');
    }

    // Retrieve stored socket_id from localStorage if available
    let socketId = localStorage.getItem('echoSocketId');

    // Reconnect using stored socket_id
    window.Echo.connector.pusher.connection.socket_id = socketId;

    // Listen for connection events
    window.Echo.connector.pusher.connection.bind('connected', () => {
        // Save the new socket_id to localStorage
        localStorage.setItem('echoSocketId', window.Echo.connector.pusher.connection.socket_id);
        // Save today's date to localStorage
        localStorage.setItem('pusherConnectionDate', currentDate);

        // Check if it's a new connection or a reconnection
        if (socketId) {
            console.log('Reconnected to Pusher');
        } else {
            console.log('Connected to Pusher for the first time');
        }
    });
} else {
    console.log('Pusher connection not needed today. Already connected earlier.');
}